import React from 'react';

const Header: React.FC = () => {
  return (
    <header className="relative z-10 w-full max-w-7xl mx-auto p-4 md:p-6 flex flex-col md:flex-row items-center justify-between gap-4">
      {/* Top Left: Logo & Title */}
      <div className="flex items-center gap-4">
        <div className="relative group">
          <div className="absolute -inset-1 bg-gradient-to-r from-christmas-gold to-christmas-red rounded-full blur opacity-25 group-hover:opacity-50 transition duration-1000"></div>
          <img 
            src="https://res.cloudinary.com/dzwotlelh/image/upload/v1764881871/60715c09-e445-4b47-8126-390b055cde92_zdtuos.jpg" 
            alt="Logo" 
            className="relative w-16 h-16 md:w-20 md:h-20 rounded-full border-2 border-christmas-gold object-cover shadow-lg"
          />
        </div>
        <div className="flex flex-col">
          <h1 className="font-festive text-3xl md:text-5xl text-white tracking-wide text-shadow-sm">
            21 DAYS
          </h1>
          <span className="text-christmas-gold font-sans text-xs md:text-sm tracking-[0.2em] font-bold">
            UNTIL CHRISTMAS
          </span>
        </div>
      </div>

      {/* Top Right: Social & CA */}
      <div className="flex flex-col items-center md:items-end gap-2">
        <a 
          href="https://twitter.com/21DaysPumpfun" 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex items-center gap-2 bg-zinc-900/80 border border-zinc-700 hover:border-christmas-gold px-4 py-2 rounded-full transition-all duration-300 group"
        >
            <span className="text-white group-hover:text-christmas-gold transition-colors">
                <svg viewBox="0 0 24 24" aria-hidden="true" className="w-5 h-5 fill-current"><g><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"></path></g></svg>
            </span>
          <span className="text-sm font-semibold text-gray-300 group-hover:text-white">@21DaysPumpfun</span>
        </a>
        <div className="flex items-center gap-2">
            <span className="text-xs text-gray-500 uppercase tracking-wider">CA:</span>
            <span className="font-mono text-christmas-gold text-sm bg-christmas-gold/10 px-2 py-0.5 rounded border border-christmas-gold/20">
                SOON
            </span>
        </div>
      </div>
    </header>
  );
};

export default Header;